import React from 'react';
import * as R from 'ramda';
import { compose, withState, withHandlers } from 'react-recompose';
// forms
import { SelectLocation } from '../../forms/forms/select-location';
import { LocationTemplateSearch } from '../../forms/forms/template-search/components/location-template-search';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
//////////////////////////////////////////////////

const searchTemplateFieldsOmit = [
  GC.FIELD_GUID,
  GC.FIELD_VERSION,
];

export const withInitialValuesFromSearchTemplate = compose(
  withState('initialValues', 'setInitialValues', ({ entity }) => entity),
  withHandlers({
    handleSearchLocation: (props) => (e) => {
      const { closeModal, branchGuid, initialValues, fromTemplate, setInitialValues } = props;

      G.stopPropagation(e);

      const searchTemplateRequest = (location) => {
        let appointmentContact = R.pathOr(null, [GC.FIELD_APPOINTMENT_CONTACT], location);

        if (R.and(fromTemplate, G.isNotNilAndNotEmpty(appointmentContact))) {
          appointmentContact = R.of(Array, appointmentContact);
        }

        const contacts = R.map(R.omit(searchTemplateFieldsOmit), R.pathOr([], ['contacts'], location));
        const locationToSave = R.mergeRight(R.omit(searchTemplateFieldsOmit, location), {
          contacts,
          appointmentContact,
        });

        setInitialValues(
          R.mergeRight(
            R.pick(
              searchTemplateFieldsOmit,
              R.or(initialValues, {}),
            ),
            locationToSave,
          ),
        );

        closeModal();
      };

      const modalContent = (
        <LocationTemplateSearch
          closeModal={closeModal}
          branchGuid={branchGuid}
          searchTemplateRequest={searchTemplateRequest}
        />
      );

      const modal = G.createCommonModalOptions(modalContent);

      props.openModal(modal);
    },
    handleSelectLocation: (props) => (e) => {
      G.stopPropagation(e);

      const searchTemplateRequest = (location) => {
        const needValues = R.pick(GC.GROUPED_FIELDS.EVENT_LOCATION_ARR, location);

        props.setInitialValues((prev) => R.mergeRight(prev, needValues));

        props.closeModal();
      };

      const modalContent = (
        <SelectLocation
          closeModal={props.closeModal}
          initialValues={props.initialValues}
          searchTemplateRequest={searchTemplateRequest}
        />
      );

      const modal = G.createCommonModalOptions(modalContent);

      props.openModal(modal);
    },
  }),
);
